import {
  resetSelectedMedicalRecordsFilters,
  selectMedicalRecordsFinding,
  selectMedicalRecordsPagination,
  setMedicalRecordsFinding,
  setMedicalRecordsPagination,
  useAppDispatch,
  useAppSelector,
} from '@/store';
import { InputSearchHandle } from '@repo/atomic-components';
import { KeyboardEvent as SyntheticKeyboardEvent, useCallback, useEffect, useRef } from 'react';

export const useMedicalRecordsSearch = () => {
  const searchInputRef = useRef<InputSearchHandle>(null);

  const medicalRecordsPagination = useAppSelector(selectMedicalRecordsPagination);
  const medicalRecordsFinding = useAppSelector(selectMedicalRecordsFinding);

  const dispatch = useAppDispatch();

  // Update search input value if URL parameters contain it (ref to useMedicalRecordsListTable)
  useEffect(() => {
    if (medicalRecordsFinding && searchInputRef.current) {
      const searchValue = searchInputRef.current.value;
      if (searchValue !== medicalRecordsFinding) {
        searchInputRef.current.value = medicalRecordsFinding;
      }
    }
  }, [medicalRecordsFinding]);

  const handleSearchInputKeyDown = (event: SyntheticKeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && searchInputRef.current) {
      const searchValue = searchInputRef.current.value;
      // Submitting a search clears any column / quick filters — the search
      // is treated as a fresh top-level query, so a stale case-status or
      // uploaded-by filter can't hide matching documents.
      dispatch(resetSelectedMedicalRecordsFilters());
      dispatch(setMedicalRecordsFinding(searchValue));
      dispatch(
        setMedicalRecordsPagination({
          ...medicalRecordsPagination,
          pageIndex: 0,
        }),
      );
    }
  };

  const handleResetClick = useCallback(() => {
    dispatch(setMedicalRecordsFinding(''));
    dispatch(
      setMedicalRecordsPagination({
        ...medicalRecordsPagination,
        pageIndex: 0,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    searchInputRef,
    handleResetClick,
    handleSearchInputKeyDown,
  };
};
